import cx from 'classnames';

import BgImage from 'src/components/BgImage/BgImage';
import { User } from 'src/types/auth';
import { CommunityMember } from 'src/types/forum';
import { avatarLabel, fullName } from '../utils';

import styles from './NameColumnContent.module.scss';

const NameColumnContent = ({
  val: member,
}: {
  val: CommunityMember | User;
}) => {
  const avatarStr = avatarLabel(member);

  const communityMemberFullName = fullName(member);

  return (
    <div className="d-flex justify-content-start align-items-center flex-shrink-0">
      {member.profile_image ? (
        <BgImage
          src={member.profile_image}
          className={cx('rounded-circle me-3')}
          width="40px"
          height="40px"
          vignette
        />
      ) : (
        <div
          className={cx(
            'rounded-circle me-3 d-flex justify-content-center align-items-center flex-shrink-0',
            styles.avatar
          )}
        >
          {avatarStr}
        </div>
      )}
      <div className="d-flex flex-column text-start" style={{ flex: '1' }}>
        <span className={styles.name}>{communityMemberFullName}</span>
        <span style={{ wordBreak: 'break-all' }}>{member.email}</span>
      </div>
    </div>
  );
};

export default NameColumnContent;
